module.exports = __webpack_public_path__ + "img/bg-carbs.94e0d6db.png";